import styled from "styled-components";

const StyledContainer = styled.div`
  background: ${({ token }) => token.background_primary};
  background-size: cover;
  box-sizing: border-box;
  font-family: Inter, sans-serif;
  height: 100vh;
  overflow: auto;

  header {
    article {
      align-items: center;
      color: #fff;
      display: flex;
      font-size: 18px;
      justify-content: space-between;
      padding: 16px 32px;

      h4 {
        margin: unset;
      }
    }

    .ant-breadcrumb-link.active {
      color: #fff;
    }

    .ant-breadcrumb .ant-breadcrumb-separator {
      color: #a5a3a3;
    }

    .ant-btn-circle {
      background: rgba(218, 226, 229, 0.6);
      height: 32px;
      width: 32px;
    }
  }

  main {
    box-sizing: border-box;
    margin: 0 auto;
    max-width: 1550px;
    min-width: 1120px;
    overflow: auto;
    padding: 24px 32px;
  }

  @media screen and (max-width: 720px) {
    main {
      padding: 24px;
    }
  }
`;

export default StyledContainer;
